const l = {
  name: "CocktailGintonic",
  dimensions: { width: 27, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 27.3 40" style="enable-background:new 0 0 27.3 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.5,0H2.9L0.5,9.5C-1.7,17.8,4,26.3,12.6,27v11H5.7v2h16v-2h-7.1V27c1.9-0.1,3.7-0.6,5.3-1.4l0,0
			c5.7-2.9,8.5-9.5,7-15.7L24.5,0z M3.2,7l1.3-5h18.4l1.2,5h-11l-2.7-2.7L9.7,5C9.2,5.6,8.7,6.3,8.4,7H3.2z M7.8,9
			c-0.3,2.1,0.4,4.3,2,6l0,0c2.7,2.7,7.2,2.7,9.9,0l0.7-0.7L15.1,9h9.5l0.3,1.3c1.3,5.3-1.1,11-6,13.4c-1.6,0.8-3.4,1.3-5.4,1.3
			c-0.3,0-0.6,0-0.8,0l0,0C5.5,24.5,0.5,17.2,2.4,10l0.3-1H7.8z M11.2,13.5c-1.7-1.7-1.9-4.4-0.6-6.3l6.9,6.9
			C15.5,15.5,12.9,15.2,11.2,13.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as CocktailGintonic
};
